import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Button from "@mui/material/Button";
import { CircularProgress, Typography } from "@mui/material";
import ImagePreview from "../ImagePreview/ImagePreview";
import { IMAGE_ENDPOINT } from "../../helpers/constants";
import {
  MainContainer,
  ImageDetails,
  TagContainer,
} from "./ImageUpload.styles";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import ImageTag from "../ImageTag/ImageTag";

export default function ImageUpload() {
  const [displayImage, setDisplayImage] = useState();
  const [image, setImage] = useState();
  const [imageCaption, setImageCaption] = useState();
  const [imageTags, setImageTags] = useState();
  const [loading, setLoading] = useState(false);

  const fileInput = useRef(null);

  async function handleFileChange(event) {
    if (event.target.files[0].size > 4000000) {
      alert("Max file size is 4MB");
      setImage();
      return;
    }

    setImageCaption();
    setImageTags();
    setImage(event.target.files[0]);
  }

  useEffect(() => {
    if (image) {
      setDisplayImage(URL.createObjectURL(image));
      setLoading(true);
      axios
        .post(IMAGE_ENDPOINT, image, {
          headers: {
            "content-type": image.type,
          },
        })
        .then((res) => {
          setImageCaption(res.data.description.captions[0]);
          setLoading(false);
          setImageTags(res.data.description.tags);
        })
        .catch((ex) => {
          // ignore for now
          setLoading(false);
          alert("Oopsie, we ran into an issue");
        });
    }

    return () => {
      setImage();
    };
  }, [image]);

  return (
    <>
      <Typography
        style={{ padding: "20px", color: "white" }}
        variant="h2"
        component="h2"
      >
        caption.ai
      </Typography>
      <MainContainer>
        <ImagePreview displayImage={displayImage} />
        <ImageDetails>
          <input
            ref={fileInput}
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          <TagContainer>
            {imageTags && imageTags.map((tag) => <ImageTag tag={tag} />)}
          </TagContainer>

          <Button
            style={{ backgroundColor: "#9AEBA3", color: "#012030" }}
            onClick={() => fileInput.current.click()}
            variant="contained"
            size="large"
          >
            Upload Image
          </Button>
          {imageCaption && imageCaption.text && (
            <p style={{ fontSize: "1.2em", color: "white" }}>
              {
                <>
                  <b>Bot says...</b> {imageCaption.text}
                </>
              }
            </p>
          )}
          {loading && <CircularProgress />}
        </ImageDetails>
      </MainContainer>
    </>
  );
}
